import React from 'react';
import { motion } from 'framer-motion';
import { useData } from '../../config/DataContext';

const Loader = () => {
  const { loadingProgress } = useData();

  return (
    <motion.div
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.6, ease: 'easeInOut' }}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black"
    >
      {/* Background glow */}
      <div className="absolute w-[300px] h-[300px] bg-cyan-500/10 rounded-full blur-[120px]"></div>
      <div className="absolute w-[200px] h-[200px] bg-blue-500/10 rounded-full blur-[100px] translate-x-20 translate-y-10"></div>

      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="relative mb-10"
      >
        <div className="flex items-center space-x-3">
          <div className="w-3 h-3 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full animate-pulse"></div>
          <span className="font-serifFont font-semibold text-white tracking-wide text-4xl italic">R</span>
          <span className="text-lg font-monoFont text-cyan-400">.dev()</span>
        </div>
      </motion.div>

      {/* Loading stages */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="flex flex-col items-center gap-5"
      >
        {/* Progress bar */}
        <div className="relative w-[200px] h-[2px] bg-white/10 rounded-full overflow-hidden">
          <motion.div
            className="absolute top-0 left-0 h-full bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full"
            animate={{ width: `${loadingProgress}%` }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          />
        </div>

        {/* Progress text */}
        <p className="text-xs font-monoFont text-gray-500 tracking-widest">
          {loadingProgress}%
        </p>

        {/* Loading status */}
        <motion.p
          key={loadingProgress}
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-[10px] font-monoFont text-gray-600 tracking-wider"
        >
          {loadingProgress < 25 && "Fetching portfolio..."}
          {loadingProgress >= 25 && loadingProgress < 50 && "Loading social links..."}
          {loadingProgress >= 50 && loadingProgress < 75 && "Loading projects..."}
          {loadingProgress >= 75 && loadingProgress < 100 && "Loading experience..."}
          {loadingProgress === 100 && "Ready"}
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

export default Loader;
